import SkeletonBase from "./SkeletonBase"
import Card, { CardContent } from "../Card"

/**
 * Skeleton pour CourseReaderPage
 * Reproduit la structure du lecteur de cours
 */
export default function CourseReaderSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header skeleton */}
      <div className="bg-white border-b shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* Back button skeleton */}
            <SkeletonBase 
              className="w-24 h-10" 
              width="6rem"
              height="2.5rem"
              rounded="rounded-md"
            />
            {/* Title skeleton */}
            <div className="flex-1 mx-4">
              <SkeletonBase 
                className="h-6 w-3/4 mx-auto" 
                width="75%"
                height="1.5rem"
              />
            </div>
            {/* Navigation buttons skeleton */}
            <div className="flex gap-2">
              <SkeletonBase 
                className="w-10 h-10 rounded-full" 
                width="2.5rem"
                height="2.5rem"
                rounded="rounded-full"
              />
              <SkeletonBase 
                className="w-10 h-10 rounded-full" 
                width="2.5rem"
                height="2.5rem"
                rounded="rounded-full"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar skeleton */}
          <div className="lg:col-span-1">
            <Card className="sticky top-24">
              <CardContent className="p-4">
                {/* Module list skeleton */}
                <div className="space-y-4">
                  {[...Array(3)].map((_, i) => (
                    <div key={i} className="space-y-2">
                      <SkeletonBase 
                        className="h-5 w-full" 
                        height="1.25rem"
                      />
                      <div className="pl-4 space-y-2">
                        {[...Array(2)].map((_, j) => (
                          <SkeletonBase 
                            key={j}
                            className="h-4 w-full" 
                            height="1rem"
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Main content skeleton */}
          <div className="lg:col-span-3">
            <Card>
              <CardContent className="p-8">
                {/* Lesson title skeleton */}
                <div className="mb-6">
                  <SkeletonBase 
                    className="h-8 w-3/4 mb-4" 
                    width="75%"
                    height="2rem"
                  />
                  <SkeletonBase 
                    className="h-5 w-1/2" 
                    width="50%"
                    height="1.25rem"
                  />
                </div>

                {/* Content blocks skeleton */}
                <div className="space-y-8">
                  {/* Video block skeleton */}
                  <div className="space-y-4">
                    <SkeletonBase 
                      className="w-full h-64" 
                      height="16rem"
                      rounded="rounded-lg"
                    />
                    <SkeletonBase 
                      className="h-4 w-full" 
                      height="1rem"
                    />
                    <SkeletonBase 
                      className="h-4 w-5/6" 
                      width="83%"
                      height="1rem"
                    />
                  </div>

                  {/* Text block skeleton */}
                  <div className="space-y-4">
                    <SkeletonBase 
                      className="h-6 w-2/3" 
                      width="66%"
                      height="1.5rem"
                    />
                    <div className="space-y-2">
                      <SkeletonBase 
                        className="h-4 w-full" 
                        height="1rem"
                      />
                      <SkeletonBase 
                        className="h-4 w-full" 
                        height="1rem"
                      />
                      <SkeletonBase 
                        className="h-4 w-4/5" 
                        width="80%"
                        height="1rem"
                      />
                    </div>
                  </div>

                  {/* Image block skeleton */}
                  <div className="space-y-4">
                    <SkeletonBase 
                      className="w-full h-48" 
                      height="12rem"
                      rounded="rounded-lg"
                    />
                    <SkeletonBase 
                      className="h-4 w-1/2" 
                      width="50%"
                      height="1rem"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
